import React, { useState,useEffect } from "react";
import "./Live.css";
import { useParams, useLocation } from "react-router-dom";





function Live() {


  const location = useLocation();
  const { img, url,name } = location.state || {}; // เผื่อกรณีโหลดหน้านี้โดยตรง

  return (

    
    <div className="App Live">
      <div className="container">
        <h2>{name} Live</h2>
      {img && <img src={img} alt={img} width="300" />}
        <div className="embed-responsive embed-responsive-16by9">
          <iframe
            id="myVideo"
            src={`${url}`}
            title="หมูเด้ง - Moo Deng Live 🔴" 
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share autoplay; encrypted-media"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div className="Heading1">
        <img src={img} alt="" />
      </div>
      <div className="Heading2"></div>
    </div>
  );
}

export default Live;
